define.alias("shared/components/shared/wizard/slide/footer", "media/components/shared/wizard/slide/footer");